"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var rgba_1 = require("./rgba"); // Alias
exports.hex = rgba_1.default;
var rgba_2 = require("./rgba"); // Alias
exports.rgb = rgba_2.default;
var rgba_3 = require("./rgba");
exports.rgba = rgba_3.default;
var hsla_1 = require("./hsla"); // Alias
exports.hsl = hsla_1.default;
var hsla_2 = require("./hsla");
exports.hsla = hsla_2.default;
var to_keyword_1 = require("./to_keyword");
exports.toKeyword = to_keyword_1.default;
var to_hex_1 = require("./to_hex");
exports.toHex = to_hex_1.default;
var to_rgba_1 = require("./to_rgba");
exports.toRgba = to_rgba_1.default;
var to_hsla_1 = require("./to_hsla");
exports.toHsla = to_hsla_1.default;
var channel_1 = require("./channel");
exports.channel = channel_1.default;
var red_1 = require("./red");
exports.red = red_1.default;
var green_1 = require("./green");
exports.green = green_1.default;
var blue_1 = require("./blue");
exports.blue = blue_1.default;
var hue_1 = require("./hue");
exports.hue = hue_1.default;
var saturation_1 = require("./saturation");
exports.saturation = saturation_1.default;
var lightness_1 = require("./lightness");
exports.lightness = lightness_1.default;
var alpha_1 = require("./alpha");
exports.alpha = alpha_1.default;
var alpha_2 = require("./alpha"); // Alias
exports.opacity = alpha_2.default;
var luminance_1 = require("./luminance");
exports.luminance = luminance_1.default;
var is_dark_1 = require("./is_dark");
exports.isDark = is_dark_1.default;
var is_light_1 = require("./is_light");
exports.isLight = is_light_1.default;
var is_valid_1 = require("./is_valid");
exports.isValid = is_valid_1.default;
var saturate_1 = require("./saturate");
exports.saturate = saturate_1.default;
var desaturate_1 = require("./desaturate");
exports.desaturate = desaturate_1.default;
var lighten_1 = require("./lighten");
exports.lighten = lighten_1.default;
var darken_1 = require("./darken");
exports.darken = darken_1.default;
var opacify_1 = require("./opacify");
exports.opacify = opacify_1.default;
var opacify_2 = require("./opacify"); // Alias
exports.fadeIn = opacify_2.default;
var transparentize_1 = require("./transparentize");
exports.transparentize = transparentize_1.default;
var transparentize_2 = require("./transparentize"); // Alias
exports.fadeOut = transparentize_2.default;
var complement_1 = require("./complement");
exports.complement = complement_1.default;
var grayscale_1 = require("./grayscale");
exports.grayscale = grayscale_1.default;
var adjust_1 = require("./adjust");
exports.adjust = adjust_1.default;
var change_1 = require("./change");
exports.change = change_1.default;
var invert_1 = require("./invert");
exports.invert = invert_1.default;
var mix_1 = require("./mix");
exports.mix = mix_1.default;
var scale_1 = require("./scale");
exports.scale = scale_1.default;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/methods/index.js
// module id = 2109
// module chunks = 0